import { cn } from '../../../../lib/utils';

export const getBubbleBaseStyles = () =>
  'relative px-4 py-2 rounded-xl w-fit text-sm leading-6 tracking-normal';

export const getBubbleRoleStyles = (role: 'user' | 'assistant') => {
  if (role === 'user') {
    return 'bg-primary text-primary-foreground rounded-tr-md ml-auto';
  }
  return 'bg-muted rounded-tl-md';
};

export const getThinkingBubbleStyles = () =>
  cn(getBubbleBaseStyles(), getBubbleRoleStyles('assistant'));

export const getThinkingDotsStyles = () =>
  'flex items-center justify-center gap-1 py-2';
